import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '-23px -96px -23px -96px',
    height: 'calc(100vh - 100px)',
    [theme.breakpoints.down('sm')]: {
      margin: 0
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '35%',
    position: 'relative',
    alignItems: 'center'
  },
  coverImageContainer: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  coverDetails: {
    width: '100%',
    height: '100%',
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  coverImage: {
    width: '100%',
    height: '100%',
    objectFit: 'fill'
  },
  logo: {
    position: 'absolute',
    top: '15%',
    left: '5%',
    [theme.breakpoints.down('md')]: {
      left: '50%',
      transform: 'translateX(-50%)'
    }
  },
  link: { position: 'absolute', top: '15%', right: '6%' },
  searchWidgetContainer: {
    display: 'flex',
    position: 'relative',
    width: '90%',
    marginTop: '-30px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-30%'
    },
    [theme.breakpoints.between('sm', 'md')]: {
      marginTop: '-9%'
    },
    borderRadius: '0px 8px 8px 8px',
    zIndex: 1
  },
  mainImageContainer: {
    position: 'absolute',
    width: '90%',
    top: '110%'
  },
  mainCoverImage: {
    height: '100%',
    width: '100%',
    objectFit: 'fill'
  }
}))
export default useStyles
